import { Pipe, PipeTransform } from '@angular/core';
import { Property } from '@app/shared/interfaces';

@Pipe({
  standalone: false,
  name: 'parentChildSetupSortPropertiesParentFirst',
})
export class ParentChildSetupSortPropertiesParentFirstPipe implements PipeTransform {
  transform(properties: Property[], parentPropertyId: number): Property[] {
    // sort the properties so that the parent property is first
    const parentProperty = properties.find((property) => property.id === parentPropertyId);
    const parentPropertyIndex = properties.indexOf(parentProperty);
    const propertiesCopy = [...properties];
    propertiesCopy.splice(parentPropertyIndex, 1);
    propertiesCopy.unshift(parentProperty);
    return propertiesCopy;
  }
}
